import { PipelineType } from '../types';

export type StageType = 'Opportunity' | 'Won' | 'Unqualified' | 'Lose';

export interface StageConfig {
  id: StageType;
  label: string;
  color: string; // Theme-compatible accent color
  pipelines: PipelineType[];
}

export const STAGES_CONFIG: StageConfig[] = [
  {
    id: 'Opportunity',
    label: 'Opportunity',
    color: '#0086f0', // Monday Blue
    pipelines: [
      'Opportunity',
      'Website Leads',
      'New Leads',
      'Attempted to Contact',
      'Cold Call Leads',
      'Quoted',
      'Revisit Later | ADD FU DATE'
    ]
  },
  {
    id: 'Won',
    label: 'Won',
    color: '#00c875', // Emerald Green
    pipelines: [
      'Won',
      'Approved',
      'Finalizing',
      'Awarded',
      'Onboarding',
      'Complete',
      'In Process',
      'Awaiting First Shipment'
    ]
  },
  {
    id: 'Unqualified',
    label: 'Unqualified',
    color: '#64748b', // Slate Gray
    pipelines: [
      'Unqualified',
      'Brokers',
      'Shipper'
    ]
  },
  {
    id: 'Lose',
    label: 'Lose',
    color: '#e2445c', // Crimson Red
    pipelines: [
      'Lose'
    ]
  }
];

/**
 * Helper to check which Stage a given pipeline belongs to
 */
export function getStageForPipeline(pipeline: PipelineType): StageType {
  const found = STAGES_CONFIG.find(stage => stage.pipelines.includes(pipeline));
  return found ? found.id : 'Opportunity';
}
